module.exports = __webpack_public_path__ + "img/file55.3e1276d7.png";